module.exports = __webpack_public_path__ + "public/images/piggie.095eff88b3dae6ce8298ebd578102944.png";